<template>
  <div class="header-full">
    <div class="container-wrapper custom-grid-header">

      <div class="header-left">
        <span class="project-name" @click="$router.push('/state')">Maya LLC</span>
        <div class="nav-menu">
          <button type="button" class="config-buttons button-dark nav-trigger">Menu</button>
          <div class="nav-dropdown">
            <div v-for="item in navItems" :key="item.label" class="nav-row">
              <button type="button" class="nav-link" @click="onNavClick(item)">{{ item.label }}</button>
              <button
                v-if="item.path"
                type="button"
                class="nav-external"
                title="Abrir em nova aba"
                @click="openInNewTab(item.path)"
              >↗</button>
            </div>
          </div>
        </div>
        <span class="clock-display">{{ currentTime }}</span>
      </div>

      <div class="left-float quotes-tape">

          <div class="tape-price">
            <span class="asset">BTC/USDC</span>
            <span class="price"> ${{ marketData.btcUsd }}</span>
          </div>

          <div class="tape-price" :title="'Atualizado em: ' + formatDate(marketData.ratesUpdatedAt)">
            <span class="asset">USDT/BRL</span>
            <span class="price"> R${{ marketData.usdtBrl.toFixed(2) }}</span>
          </div>

          <div class="tape-price" :title="'Atualizado em: ' + formatDate(marketData.ratesUpdatedAt)">
            <span class="asset">BTC/BRL</span>
            <span class="price"> R${{ marketData.btcBrl }}</span>
          </div>

      </div>

        <div class="right-float system-buttons">
          <span class="target-margin-box">
            <span class="target-margin-label">target%</span>
            <input
              v-model="targetMarginDraft"
              class="target-margin-input"
              type="number"
              step="0.1"
              min="0.1"
              @change="commitTargetMargin"
              @keyup.enter="commitTargetMargin"
            />
          </span>
          <span class="text-boxed system-status">{{ systemStatusIcon }} system</span>
          <span><button class="config-buttons button-dark" @click="$emit('toggle-sidebar')">☰</button></span>
        </div>

      </div>
    </div>
</template>

<script>
import { inject } from 'vue';
import { mapState } from 'vuex';
import manualOrdersForm from '@/forms/manualOrdersForm.vue';
import systemParametersForm from '@/forms/systemParameters.vue';
import adjustHedgeForm from '@/forms/adjustHedge.vue';
import { formatDate } from '@/utils/funcs';

export default {
  name: "headerAll",
  emits: ['toggle-sidebar'],
  data() {
    return { currentTime: '', targetMarginDraft: '0.6' };
  },
  setup() {
    const openModal = inject('openModal');

    function openModalWindow(objectForm) {
      openModal(objectForm);
    }

    return { openModalWindow, manualOrdersForm, systemParametersForm, adjustHedgeForm };
  },
  methods: {
    formatDate,
    commitTargetMargin() {
      this.$store.commit('setTargetMarginPct', this.targetMarginDraft)
      this.targetMarginDraft = Number(this.targetMarginPct || 0.6).toFixed(2)
    },
    onNavClick(item) {
      if (item.modal) this.openModalWindow(item.modal)
      else if (item.path) this.$router.push(item.path)
    },
    openInNewTab(path) {
      const { href } = this.$router.resolve(path)
      window.open(href, '_blank', 'noopener')
    },
  },
  computed: {
    ...mapState({
      systemInfos: state => state.systemInfos,
      marketData: state => state.marketData,
      targetMarginPct: state => state.targetMarginPct,
    }),
    navItems() {
      return [
        { label: 'hedge', modal: adjustHedgeForm },
        { label: 'manuals', modal: manualOrdersForm },
        { label: 'sysParams', modal: systemParametersForm },
        { label: 'Tools', path: '/tools' },
        { label: 'PnL', path: '/pnl' },
        { label: 'Terminal', path: '/terminal' },
        { label: 'Portfolio', path: '/analyze' },
        { label: 'IDI Chart', path: '/idi-chart' },
      ]
    },
    systemStatusIcon() {
      const systemStatus = this.systemInfos.systemStatus
      return systemStatus ?  "✅" : "❌";
    },
  },
  mounted() {
    this.targetMarginDraft = Number(this.targetMarginPct || 0.6).toFixed(2)
    const tick = () => {
      this.currentTime = new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
    };
    tick();
    this._clock = setInterval(tick, 1000);
  },
  watch: {
    targetMarginPct(newValue) {
      this.targetMarginDraft = Number(newValue || 0.6).toFixed(2)
    },
  },
  beforeUnmount() {
    clearInterval(this._clock);
  }
}
</script>

<style>
.quotes-tape {
  display: flex;
  justify-content: right;
}
.custom-grid-header {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  overflow: visible;
}
.system-status {
    padding: 10px 2px !important;
    text-align: center;
}
.header-full {
    width: 100%;
    float: left;
    height: 60px;
    padding: 5px;
    display: flex;
    align-items: center;
    border-bottom: 1px dotted #535353;
    overflow: visible;
    position: relative;
    z-index: 80;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.nav-menu {
  position: relative;
}

.nav-trigger {
  margin-left: 0;
}

.nav-dropdown {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  min-width: 210px;
  padding: 6px;
  background: var(--box-section-bgcolor);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.28);
  z-index: 50;
}

.nav-dropdown::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: -8px;
  height: 8px;
}

.nav-menu:hover .nav-dropdown,
.nav-menu:focus-within .nav-dropdown {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.nav-row {
  display: flex;
  align-items: center;
  gap: 4px;
}

.nav-dropdown .nav-link,
.nav-dropdown .nav-external {
  background: transparent;
  color: var(--text-color);
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px !important;
}

.nav-dropdown .nav-link {
  flex: 1;
  text-align: left;
  padding: 8px 10px;
}

.nav-dropdown .nav-external {
  width: 32px;
  padding: 8px 0;
  font-size: 14px !important;
  opacity: 0.75;
}

.nav-dropdown .nav-link:hover,
.nav-dropdown .nav-external:hover {
  background: var(--table-row-hover);
  opacity: 1;
}

.tape-price {
  float: right;
  margin: 5px 30px 0 30px;
}

.tape-price .price {
  font-size: 1.4rem;
}

.system-buttons {
  text-align: right;
  gap: 0 !important;
}

.target-margin-box {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-right: 10px;
}

.target-margin-label {
  font-size: 11px;
  opacity: 0.8;
}

.target-margin-input {
  width: 64px;
  border: 1px solid var(--table-row-border, #3a3a3a);
  border-radius: 6px;
  background: transparent;
  color: var(--text-color);
  padding: 2px 6px;
  font-size: 12px;
}

.project-name {
  margin-top: 2px;
  font-weight: bold;
  font-size: 1.5rem;
  cursor: pointer;
}

.config-buttons {
  font-size: 12px;
  margin-left: 10px;
}

.clock-display {
  font-size: 1.2rem;
}

</style>
